import { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";
import { Button } from "@/components/ui/button";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

/** Invite à installer l'app sur l'écran d'accueil (Android/Chrome, avec repli iOS). */
export default function InstallPrompt() {
  const [prompt, setPrompt] = useState(null);
  const [showIos, setShowIos] = useState(false);
  const [hidden, setHidden] = useState(() => localStorage.getItem("install_dismissed") === "1");

  useEffect(() => {
    if (isStandalone()) return setHidden(true);
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", () => { setPrompt(null); setHidden(true); });
    const ios = /iphone|ipad|ipod/i.test(navigator.userAgent);
    const mobile = /android|iphone|ipad|ipod/i.test(navigator.userAgent);
    if (ios && mobile) setShowIos(true);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => { localStorage.setItem("install_dismissed", "1"); setHidden(true); };

  if (hidden || (!prompt && !showIos)) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[9999] mx-auto max-w-md rounded-2xl border border-white/10 bg-[#0F172A] text-white shadow-2xl p-4"
      data-testid="install-banner">
      <div className="flex items-start gap-3">
        <img src="/icons/icon-192.png" alt="" className="w-11 h-11 rounded-xl shrink-0" />
        <div className="flex-1">
          <div className="font-semibold text-sm">Installer Innova Route</div>
          <div className="text-xs text-white/70 mt-0.5">
            {prompt
              ? "Ajoutez l'icône sur votre écran d'accueil : ouverture plein écran et fonctionnement hors réseau."
              : "Touchez le bouton Partager puis « Sur l'écran d'accueil »."}
          </div>
          {prompt && (
            <Button size="sm" className="mt-3 bg-amber-400 text-[#0F172A] hover:bg-amber-300" data-testid="install-btn"
              onClick={async () => { prompt.prompt(); await prompt.userChoice; setPrompt(null); setHidden(true); }}>
              <Download className="w-4 h-4 mr-1.5" /> Installer l'application
            </Button>
          )}
          {!prompt && showIos && (
            <div className="mt-2 flex items-center gap-1.5 text-xs text-white/60"><Share className="w-4 h-4" /> Safari → Partager → Sur l'écran d'accueil</div>
          )}
        </div>
        <button onClick={dismiss} className="text-white/50 hover:text-white p-1" data-testid="install-dismiss" aria-label="Fermer">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
